export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Luxury%20fashion%20editorial%20backdrop%20with%20warm%20champagne%20and%20terracotta%20abstract%20gradient%2C%20soft%20flowing%20silk%20texture%2C%20elegant%20minimalist%20composition%2C%20golden%20hour%20warmth%2C%20magazine%20cover%20aesthetic%2C%20rich%20amber%20and%20cream%20tones%2C%20no%20text%20no%20logos&width=1800&height=900&seq=hero-v2-2026&orientation=landscape"
        alt="CSSBuy Spreadsheet Portugal e Brasil 2026"
        title="CSSBuy Spreadsheet Portugal e Brasil 2026"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
        <h1 className="text-white text-3xl md:text-5xl lg:text-6xl font-extrabold text-center leading-tight max-w-4xl drop-shadow-md">
          O Maior CSSBuy Spreadsheet em Português
        </h1>
        <p className="text-white/85 text-sm md:text-lg mt-4 md:mt-6 max-w-2xl text-center leading-relaxed">
          Encontre os melhores links CSSBuy atualizados, vendedores confiáveis, guias completos e produtos verificados em português.
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-3 mt-8 md:mt-10">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="bg-white text-foreground-950 font-bold px-8 py-3.5 rounded-full text-sm md:text-base whitespace-nowrap cursor-pointer hover:bg-white/90 transition-all duration-200 shadow-md"
          >
            Ver Planilha CSSBuy
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="bg-primary-500 text-white font-bold px-8 py-3.5 rounded-full text-sm md:text-base whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-all duration-200 shadow-md"
          >
            Explorar Produtos
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-8 mt-10 md:mt-12">
          <span className="text-white/75 text-xs md:text-sm whitespace-nowrap font-medium">
            <i className="ri-check-line mr-1.5"></i> Links verificados
          </span>
          <span className="text-white/75 text-xs md:text-sm whitespace-nowrap font-medium">
            <i className="ri-check-line mr-1.5"></i> Atualizado semanalmente
          </span>
          <span className="text-white/75 text-xs md:text-sm whitespace-nowrap font-medium">
            <i className="ri-check-line mr-1.5"></i> Guias em português
          </span>
          <span className="text-white/75 text-xs md:text-sm whitespace-nowrap font-medium">
            <i className="ri-check-line mr-1.5"></i> Produtos populares
          </span>
          <span className="text-white/75 text-xs md:text-sm whitespace-nowrap font-medium">
            <i className="ri-check-line mr-1.5"></i> Compra segura
          </span>
        </div>
      </div>
    </section>
  );
}